<template>
    <div class="m-0">
        <div class="d-flex align-items-center collapsible py-3 toggle mb-0 collapsed" data-bs-toggle="collapse" :data-bs-target="'#kt_status_'+id" aria-expanded="false">
            <div class="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
                <span class="svg-icon toggle-on svg-icon-primary svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"></rect>
                        <rect x="6.0104" y="10.9247" width="12" height="2" rx="1" fill="currentColor"></rect>
                    </svg>
                </span> 
                <span class="svg-icon toggle-off svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"></rect>
                        <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor"></rect>
                        <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor"></rect>
                    </svg>
                </span>
            </div>
            <div class="d-flex justify-content-between align-items-center cursor-pointer w-100">
                <span class="fs-4 fw-bold mb-0"  :style="{ color: status.color }">{{status.title}}</span>
                <span class="text-primary fs-5 fw-bolder mb-0">{{status?.tasks?.length}} {{ $t("reports.tasks") }}</span>
            </div>
        </div>
        <div class="separator separator-dashed"></div>
        <div :id="'kt_status_'+id" class="fs-6 ms-1 collapse px-" style="">
            <TaskCard 
                :id="'task_'+i"
                v-for="(task, i) in status?.tasks"
                :project="project"
                :task="task"
                :handleTaskSelected="handleTaskSelected"
                @callback="$emit('callback')"
            />
        </div>
    </div>
</template>
<script setup>
import { defineEmits } from 'vue'
import TaskCard from './TaskCard.vue'
import { computed } from 'vue'


const emit = defineEmits(['callback'])
const props = defineProps({
    status: {
        type: Object,
        default: {
            id: "",
            title: "",
            color: "",
            tasks: []
        }
    },
    id: {
        type: [String, Number],
        default: "id"
    },
    count: {
        type: Number,
        default: 1
    },
    project: {
        type: String,
        default: "id"
    }, 
    handleTaskSelected: {
        type: Function,
        default: () => {}
    },
        
})

const isLast = computed(() => parseInt(props.id) == props.count-1)

</script>
<style scoped>
.collapsible {
    transition: background-color 0.3s ease;
}

.collapse.show + .collapsible {
    background-color: rgba(0, 123, 255, 0.1); /* Exemple de couleur */
}
</style>